import Header from "user/components/common/Header";
import { ReactComponent as Empty } from "../../common/assets/icons/empty.svg";

export default function NotFound() {
    return (
        <div className="h-[100dvh] flex flex-col items-center">
            <Header goBack />
            <div className="flex-1 flex flex-col gap-[40px] justify-center">
                <Empty />
                <p>현재 페이지를 찾을 수 없습니다.</p>
            </div>
        </div>
    );
}
